import controller from './wf-node-editor.controller';
import template from './wf-node-editor.html';
import './wf-node-editor.scss';

export default {
	controller,
	template,
	bindings: {
		disabled: '<?ngDisabled',
		selected: '<ngModel',
	},
	require: {
		editor: '^^wfEditor',
	},
};
